(() => {
  if (window.heliorJournalTrackingReady) return;
  window.heliorJournalTrackingReady = true;
  const articleHandle = 'platinum-chain-width-length-guide';
  document.addEventListener('click', (event) => {
    const anchor = event.target.closest?.('a[data-journal-product-link], a[data-chain-guide-link]');
    if (!anchor) return;
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
    const isProduct = anchor.hasAttribute('data-journal-product-link');
    const name = isProduct ? 'journal_product_click' : 'chain_guide_open';
    const url = new URL(anchor.href, window.location.origin);
    const payload = {
      article_handle: articleHandle,
      link_placement: anchor.dataset.linkPlacement || 'article_body',
      destination_path: url.pathname,
      product_handle: isProduct ? url.pathname.split('/products/')[1] || '' : ''
    };
    try {
      if (typeof window.Shopify?.analytics?.publish === 'function') {
        Promise.resolve(window.Shopify.analytics.publish('helior:' + name, payload)).catch(() => {});
      }
      if (typeof window.gtag === 'function') window.gtag('event', name, payload);
    } catch (_) {}
  });
})();